/**
 * Standard material profiles database.
 * Each entry clearly distinguishes:
 * 1. Physical properties (density)
 * 2. Reference parameters from military engineering literature (RHA baselines)
 * 3. Gameplay calibrated resistance multipliers (not claimed as unclassified military secrets)
 */
export const MATERIAL_PROFILES = {
    steel: {
        id: 'steel',
        name: 'Rolled Homogeneous Armor (RHA Steel)',
        classification: 'reference',
        densityKgM3: 7850,
        rhaEquivalentKinetic: 1.0,
        rhaEquivalentChemical: 1.0,
        brinellHardness: 300,
        restitution: 0.15,
        velocityAttenuationPerMm: 0.0035,
        spallMultiplier: 1.0,
        notes: 'Reference benchmark armor material (MIL-A-12560 standard).',
    },
    composite: {
        id: 'composite',
        name: 'Advanced Composite Matrix (Ceramic/Aramid/Steel)',
        classification: 'gameplay_calibrated',
        densityKgM3: 3200,
        rhaEquivalentKinetic: 1.35,
        rhaEquivalentChemical: 2.1,
        brinellHardness: 1400,
        restitution: 0.08,
        velocityAttenuationPerMm: 0.0055,
        spallMultiplier: 0.45,
        notes: 'Layered ceramic tiles dissipate shaped charge jets and shatter kinetic penetrators.',
    },
    rubber: {
        id: 'rubber',
        name: 'Reinforced Elastomer / Side Skirt Rubber',
        classification: 'gameplay_calibrated',
        densityKgM3: 1200,
        rhaEquivalentKinetic: 0.1,
        rhaEquivalentChemical: 0.4,
        brinellHardness: 65,
        restitution: 0.65,
        velocityAttenuationPerMm: 0.0008,
        spallMultiplier: 0.05,
        notes: 'Primary role is detonating HEAT fuses prematurely before the main hull.',
    },
    concrete: {
        id: 'concrete',
        name: 'Reinforced Ballistic Concrete',
        classification: 'reference',
        densityKgM3: 2400,
        rhaEquivalentKinetic: 0.25,
        rhaEquivalentChemical: 0.3,
        brinellHardness: 180,
        restitution: 0.1,
        velocityAttenuationPerMm: 0.0012,
        spallMultiplier: 1.4,
        notes: 'Structural bunker protection; produces significant concrete spalling when penetrated.',
    },
    soil: {
        id: 'soil',
        name: 'Compacted Battlefield Earth',
        classification: 'reference',
        densityKgM3: 1600,
        rhaEquivalentKinetic: 0.08,
        rhaEquivalentChemical: 0.12,
        brinellHardness: 20,
        restitution: 0.02,
        velocityAttenuationPerMm: 0.0004,
        spallMultiplier: 0.0,
        notes: 'Earth embankments and berms absorb blast and kinetic rounds gradually.',
    },
    wood: {
        id: 'wood',
        name: 'Hardwood Ballistic Timber',
        classification: 'gameplay_calibrated',
        densityKgM3: 700,
        rhaEquivalentKinetic: 0.05,
        rhaEquivalentChemical: 0.05,
        brinellHardness: 35,
        restitution: 0.2,
        velocityAttenuationPerMm: 0.0002,
        spallMultiplier: 0.25,
        notes: 'Improvised tactical barricades and trench shoring.',
    },
    glass: {
        id: 'glass',
        name: 'Multi-layer Ballistic Laminated Glass',
        classification: 'gameplay_calibrated',
        densityKgM3: 2500,
        rhaEquivalentKinetic: 0.45,
        rhaEquivalentChemical: 0.5,
        brinellHardness: 450,
        restitution: 0.05,
        velocityAttenuationPerMm: 0.002,
        spallMultiplier: 1.2,
        notes: 'Commander vision cupola and driver periscope protective blocks.',
    },
    water: {
        id: 'water',
        name: 'Water Barrier / Wet Ammunition Rack',
        classification: 'reference',
        densityKgM3: 1000,
        rhaEquivalentKinetic: 0.04,
        rhaEquivalentChemical: 0.04,
        brinellHardness: 0,
        restitution: 0.01,
        velocityAttenuationPerMm: 0.0001,
        spallMultiplier: 0.0,
        notes: 'Fluid boundary and wet stowage extinguishing medium.',
    },
};
export function getMaterialProfile(id) {
    const profile = MATERIAL_PROFILES[id];
    if (!profile) {
        return MATERIAL_PROFILES.steel;
    }
    return profile;
}
//# sourceMappingURL=materials.js.map